module.exports = __webpack_public_path__ + "img/Comorbidity_CVD.4f230a8d.jpg";